import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { RefundVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const retrieveRefundList = createAsyncThunk<RefundVM[], void, { extra: Partial<Dependencies> }>(
  "refunds/retrieveRefundList",
  async (_: void, { extra: { adminRepository } }) => {
    return adminRepository!.listRefunds();
  },
);
